module.exports = __webpack_public_path__ + "be6485cecc8295363e6df9fc9b947ce5.mp4";